module.exports = __webpack_public_path__ + "img/solidity.7937b514.png";